import { inject, observer } from "mobx-react";
import * as React from "react";
import { Link } from "react-router-dom";
import { SimpleCustomer } from "src/model/Customer";

import { faChartArea } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { HorseForSaleStore } from "../../stores/HorseForSaleStore";
import ProfileLink from "../common/ProfileLink";
import AddressesOfHFSByInspectionDate from "./AddressesOfHFSByInspectionDate";
import BuyersGroupedByInsuranceCompany from "./BuyersGroupedByInsuranceCompany";
import CustomerEmails from "./CustomerEmails";
import FinalSaleReport from "./FinalSaleReport";
import FinancialReportsForSelectedConsignor from "./FinancialReportsForSelectedConsignor";
import FinancialSummaryReport from "./FinancialSummaryReport";
import FullCircleProgramEnrollment from "./FullCircleProgramEnrollment";
import HFSComplianceStatus from "./HFSComplianceStatus";
import HFSMasterlist from "./HFSMasterlist";
import HFSPreviewReport from "./HFSPreviewReport";
import HipNumAndConsignors from "./HipNumAndConsignors";
import HorsesWithdrawnWithoutVetCertificate from "./HorsesWithdrawnWithoutVetCertificate";
import Indexes from "./Indexes";
import InformationForCatalog from "./InformationForCatalog";
import StakeEngagementsList from "./StakeEngagementsList";
// import YearlingAverageSalePriceByDam from "./YearlingAverageSalePriceByDam";
import TotalCommisionsCollected from "./TotalCommisionsCollected";
import TotalHSTCollected from "./TotalHSTCollected";
import NewHorsesEnteredByYear from "./NewHorsesEnteredByYear";

export interface Props {
    horseForSaleStore?: HorseForSaleStore;
    currentTab: string;
    consignors?: Array<SimpleCustomer> | null;
}
export interface State {}

export default class ReportsTemplate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active" aria-current="page">
                            Reports
                        </li>
                    </ol>
                </nav>
                <div className="content">
                    <div className="row">
                        <div className="col-8">
                            <h1>
                                <span>
                                    <FontAwesomeIcon icon={faChartArea} size="2x" className="mr-2 color-info" />
                                </span>
                                Reports
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 col-lg-4 col-xl-3">
                            <div className="card mb-0 rounded-top border-bottom-0">
                                <div className="card-header editable-card-header py-2">General</div>
                                <nav className="flex-column intern-navigation px-0 py-0">
                                    <ul className="mx-0 my-0">
                                        <ProfileLink
                                            label="Customer emails"
                                            type="reports"
                                            page="customer-emails"
                                            active={this.props.currentTab === "customer-emails"}
                                        />
                                        <ProfileLink
                                            label="Hips #s and Consignors"
                                            type="reports"
                                            page="hip-nums-and-consignors"
                                            active={this.props.currentTab === "hip-nums-and-consignors"}
                                        />
                                        <ProfileLink
                                            label="Full Circle Program Enrollment"
                                            type="reports"
                                            page="full-circle-program-enrollment"
                                            active={this.props.currentTab === "full-circle-program-enrollment"}
                                        />
                                        <ProfileLink
                                            label="Horses for Sale Masterlist"
                                            type="reports"
                                            page="horses-for-sale-masterlist"
                                            active={this.props.currentTab === "horses-for-sale-masterlist"}
                                        />
                                        <ProfileLink
                                            label="New Horses Entered in The System by Year"
                                            type="reports"
                                            page="new-horses-entered-in-the-system-by-year"
                                            active={this.props.currentTab === "new-horses-entered-in-the-system-by-year"}
                                        />
                                    </ul>
                                </nav>
                            </div>
                            <div className="card mb-0 rounded-0 border-bottom-0">
                                <div className="card-header editable-card-header py-2">Inspection</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul className="mx-0 my-0">
                                        <ProfileLink
                                            label="Addresses of Horses for Sale by Inspection Date"
                                            type="reports"
                                            page="address-of-horses-for-sale-by-inspection-date"
                                            active={this.props.currentTab === "address-of-horses-for-sale-by-inspection-date"}
                                        />
                                    </ul>
                                </nav>
                            </div>
                            <div className="card mb-0 rounded-0 border-bottom-0">
                                <div className="card-header editable-card-header py-2">Compliance</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul className="mx-0 my-0">
                                        {/* <ProfileLink
                                            label="Non-compliant Horses for Sale"
                                            type="reports"
                                            page="non-compliant-horses-for-sale"
                                            active={this.props.currentTab === "non-compliant-horses-for-sale"}
                                        /> */}
                                        <ProfileLink
                                            label="Horses for Sale Compliance Status"
                                            type="reports"
                                            page="horses-for-sale-compliance-status"
                                            active={this.props.currentTab === "horses-for-sale-compliance-status"}
                                        />
                                    </ul>
                                </nav>
                            </div>
                            <div className="card mb-0 rounded-0 border-bottom-0">
                                <div className="card-header editable-card-header py-2">Catalog</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul className="mx-0 my-0">
                                        <ProfileLink
                                            label="Horses for Sale Preview Report"
                                            type="reports"
                                            page="horses-for-sale-preview-report"
                                            active={this.props.currentTab === "horses-for-sale-preview-report"}
                                        />
                                        <ProfileLink label="Indexes" type="reports" page="indexes" active={this.props.currentTab === "indexes"} />
                                        <ProfileLink
                                            label="Information for Catalog"
                                            type="reports"
                                            page="information-for-catalog"
                                            active={this.props.currentTab === "information-for-catalog"}
                                        />
                                        <ProfileLink
                                            label="Stake Engagements List"
                                            type="reports"
                                            page="stake-engagements-list"
                                            active={this.props.currentTab === "stake-engagements-list"}
                                        />
                                    </ul>
                                </nav>
                            </div>
                            <div className="card mb-0 rrounded-0 border-bottom-0">
                                <div className="card-header editable-card-header py-2">Insurance</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul className="mx-0 my-0">
                                        <ProfileLink
                                            label="Buyers Grouped by Insurance Company"
                                            type="reports"
                                            page="buyers-grouped-by-insurance-company"
                                            active={this.props.currentTab === "buyers-grouped-by-insurance-company"}
                                        />
                                        {/* <ProfileLink
                                            label="Buyers without insurance"
                                            type="reports"
                                            page="buyers-without-insurance"
                                            active={this.props.currentTab === "buyers-without-insurance"}
                                        /> */}
                                    </ul>
                                </nav>
                            </div>
                            <div className="card mb-0 rounded-bottom">
                                <div className="card-header editable-card-header py-2">Post-sale</div>
                                <nav className="flex-column  intern-navigation">
                                    <ul className="mx-0 my-0">
                                        <ProfileLink
                                            label="Financials Report for Selected Consignor"
                                            type="reports"
                                            page="financial-reports-for-selected-consignor"
                                            active={this.props.currentTab === "financial-reports-for-selected-consignor"}
                                        />
                                        <ProfileLink
                                            label="Financial Summary Report"
                                            type="reports"
                                            page="financial-summary-report"
                                            active={this.props.currentTab === "financial-summary-report"}
                                        />
                                        <ProfileLink
                                            label="Final Sale Report"
                                            type="reports"
                                            page="final-sale-report"
                                            active={this.props.currentTab === "final-sale-report"}
                                        />
                                        <ProfileLink
                                            label="Horses withdrawn without vet certificate"
                                            type="reports"
                                            page="horses-withdrawn-without-vet-certificate"
                                            active={this.props.currentTab === "horses-withdrawn-without-vet-certificate"}
                                        />
                                        {/* <ProfileLink
                                            label="Total Commisssions Collected"
                                            type="reports"
                                            page="total-commisssions-collected"
                                            active={this.props.currentTab === "total-commisssions-collected"}
                                        />
                                        <ProfileLink
                                            label="Total HST Collected"
                                            type="reports"
                                            page="total-hst-collected"
                                            active={this.props.currentTab === "total-hst-collected"}
                                        /> */}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="col-md-9 col-lg-8 col-xl-9">
                            {this.props.currentTab === "customer-emails" && <CustomerEmails />}
                            {this.props.currentTab === "address-of-horses-for-sale-by-inspection-date" && <AddressesOfHFSByInspectionDate />}
                            {this.props.currentTab === "horses-for-sale-compliance-status" && <HFSComplianceStatus />}
                            {/* {this.props.currentTab === "non-compliant-horses-for-sale" && <NonCompliantHFS/>} */}
                            {this.props.currentTab === "horses-for-sale-preview-report" && <HFSPreviewReport />}
                            {this.props.currentTab === "indexes" && <Indexes />}
                            {this.props.currentTab === "information-for-catalog" && <InformationForCatalog />}
                            {this.props.currentTab === "buyers-grouped-by-insurance-company" && <BuyersGroupedByInsuranceCompany />}
                            {this.props.currentTab === "final-sale-report" && <FinalSaleReport />}
                            {/* {this.props.currentTab === "yearling-average-sale-price-by-dam" && <YearlingAverageSalePriceByDam/>} */}
                            {this.props.currentTab === "horses-withdrawn-without-vet-certificate" && <HorsesWithdrawnWithoutVetCertificate />}
                            {this.props.currentTab === "total-commisssions-collected" && <TotalCommisionsCollected />}
                            {this.props.currentTab === "total-hst-collected" && <TotalHSTCollected />}
                            {this.props.currentTab === "hip-nums-and-consignors" && <HipNumAndConsignors />}
                            {this.props.currentTab === "full-circle-program-enrollment" && <FullCircleProgramEnrollment />}
                            {this.props.currentTab === "horses-for-sale-masterlist" && <HFSMasterlist />}
                            {this.props.currentTab === "stake-engagements-list" && <StakeEngagementsList />}
                            {this.props.currentTab === "financial-reports-for-selected-consignor" && <FinancialReportsForSelectedConsignor />}
                            {this.props.currentTab === "financial-summary-report" && <FinancialSummaryReport />}
                            {this.props.currentTab === "new-horses-entered-in-the-system-by-year" && <NewHorsesEnteredByYear />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/ReportsTemplate.tsx